import apiClient from './apiClient';
import { Profile, ProfileWithUser } from '../types';

export interface CreateProfileData {
  firstName: string;
  bio: string;
  department: string;
  year: number;
  interests: string[];
}

export interface UpdateProfileData extends Partial<CreateProfileData> {}

export const profileApi = {
  getMyProfile: async (): Promise<ProfileWithUser> => {
    const response = await apiClient.get<ProfileWithUser>('/profile');
    return response.data;
  },

  createProfile: async (data: CreateProfileData): Promise<Profile> => {
    const response = await apiClient.post<Profile>('/profile', data);
    return response.data;
  },

  updateProfile: async (data: UpdateProfileData): Promise<Profile> => {
    const response = await apiClient.put<Profile>('/profile', data);
    return response.data;
  },

  uploadPhoto: async (file: File): Promise<{ url: string; photoId: string }> => {
    const formData = new FormData();
    formData.append('photo', file);
    
    const response = await apiClient.post('/profile/photos', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return response.data;
  },

  deletePhoto: async (photoId: string): Promise<void> => {
    await apiClient.delete(`/profile/photos/${photoId}`);
  },
};
